module.exports = __webpack_public_path__ + "static/31-237f46d8b74db07637260f4c3d80c712.png";